import { useMemo } from "react";

import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { SelectedOrganizationIdGenerator } from "@/Common/Api/MedfarDictionaries/Dto/Responses/SelectedOrganizationIdGenerator";
import { FilteredOrganizationRules } from "@/Common/Utilities/FilteredOrganizationRules";

/**
 * Used to generate the title options according to the organization rules and selected organization provided.
 * @param filteredOrganizationRules Filtered organization rules.
 * @param selectedOrganizationIdentifier The current selected organization id
 * @returns The title options associated with the selected organization.
 */
export const useTitleOptionsForSelectedOrganization = (filteredOrganizationRules: FilteredOrganizationRules, selectedOrganizationIdentifier: string): LicenceOrganisationRule[] => useMemo(
    () => {
        if (IsNullOrWhiteSpace(selectedOrganizationIdentifier))
            return [];

        if (selectedOrganizationIdentifier === SelectedOrganizationIdGenerator.noOrganizationCode)
            return filteredOrganizationRules.getNoOrganizationTitles();

        const organizationCode = SelectedOrganizationIdGenerator.extractOrgCode(selectedOrganizationIdentifier);
        const countryCode = SelectedOrganizationIdGenerator.extractCountryCode(selectedOrganizationIdentifier);
        const stateCode = SelectedOrganizationIdGenerator.extractStateCode(selectedOrganizationIdentifier);
        return filteredOrganizationRules.getTitlesOfOrganization(organizationCode, countryCode, stateCode);
    },
    [filteredOrganizationRules, selectedOrganizationIdentifier]
);
